import Load from 'components/Load';
import { createNavigationalRoute } from 'modules/app/components/NavigationalLayout';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncSustainabilityPage = Load(
  () =>
    import(
      /* webpackChunkName: "sustainability-page" */ './containers/SustainabilityContainer'
    ),
);

export const sustainabilityRoute: RouteDescriptor = {
  id: 'landings.sustainability',
  path: `${basePath}/sustainability/*`,
  label: 'Sustainability Landing',
  audience: 'both',
  layout: 'navigational',
  module: 'landings/sustainability',
};

export const sustainabilityRoutes = [
  createNavigationalRoute({
    key: sustainabilityRoute.id,
    id: sustainabilityRoute.id,
    path: sustainabilityRoute.path,
    component: AsyncSustainabilityPage,
    handle: createRouteHandle(sustainabilityRoute),
    showSearchInNavbar: false,
    noNavbar: isCordova(),
    showBottomNavigation: true,
    transparentNavbar: true,
  }),
];

export const sustainabilityRouteDescriptors = [sustainabilityRoute];

export default sustainabilityRoutes;
